import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { initSentry } from './lib/sentry';
import App from './App';
import reportWebVitals from './reportWebVitals';

initSentry();

// ── Stale chunk retry ──────────────────────────────────────────────────────
// After a deploy, cached JS chunks 404 and return HTML → "Unexpected token '<'"
// Detect this and force-reload once to pick up the new chunks.
window.addEventListener('unhandledrejection', (event) => {
  const msg = String(event.reason?.message || event.reason || '');
  if (
    msg.includes('Unexpected token') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError')
  ) {
    const key = 'arete_chunk_reload';
    if (!sessionStorage.getItem(key)) {
      sessionStorage.setItem(key, '1');
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
